import { render } from "./PlanConsolidacion.vue?vue&type=template&id=1c12e9a2&scoped=true"
import script from "./PlanConsolidacion.vue?vue&type=script&lang=js"
export * from "./PlanConsolidacion.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./PlanConsolidacion.vue?vue&type=style&index=1&id=1c12e9a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c12e9a2"]])

export default __exports__